import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExamComponent } from './exam/exam.component';
import { LoginComponent } from './login/login.component';
import { PatientsComponent } from './patients/patients.component';
import {PatexamsComponent} from './patexams/patexams.component';
import { PatientRedirectComponent } from './patient-redirect/patient-redirect.component';
import { PrintComponent } from './print/print.component';
import {RemotevideoComponent} from './remotevideo/remotevideo.component';
import { CardioPrintComponent } from './cardio/cardio-print/cardio-print.component';
import { UsGeneralPrintComponent } from './Gastro/usgeneral-print/usgeneral-print.component';
import { EndoscopyPrintComponent } from './endoscopy/endoscopy-print/endoscopy-print.component';
import { GsprintFormComponent } from './Gastro/gsprint-form/gsprint-form.component';
import { CustomheaderComponent } from './customheader/customheader.component';
import { StatsComponent } from './stats/stats.component';
import { PrintstatsComponent } from './Gastro/printstats/printstats.component';
import { SearchtextComponent } from './searchtext/searchtext.component';
import { PrintreportComponent } from './printreport/printreport.component';
import { PrintcalendarComponent } from './printcalendar/printcalendar.component';
import { PrintPathologyFormComponent } from './print-pathology-form/print-pathology-form.component';
import { WaitingListComponent } from './waiting-list/waiting-list.component';
import { LabresultsComponent } from './labresults/labresults.component';  
import { BiopsystatsComponent } from './biopsystats/biopsystats.component';
import { MessengerReportComponent } from './messenger-report/messenger-report.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TrainingHubComponent } from './training-hub/training-hub.component';
import { PrescriptionPrintComponent } from './prescription/prescription-print/prescription-print.component';
import { BloodTestReferralPrintComponent } from './blood-test-referral/blood-test-referral-print/blood-test-referral-print.component';
import { PrintUsgConsentComponent } from './print-usg-consent/print-usg-consent.component';
import { ClinicTemplatesComponent } from './clinic-templates/clinic-templates.component';
import { ClinicAutotextComponent } from './clinic-autotext/clinic-autotext.component';
import { ClinicExamPrintComponent } from './clinic-exam-print/clinic-exam-print.component';

const routes: Routes = [
  { path: 'exam', component: ExamComponent },
  {path: 'patsearch', component: PatientsComponent},
  {path: 'patsearch/:code', component: PatientRedirectComponent},
  {path: 'patsearch/:code/:pid', component: PatientRedirectComponent},
  {path: 'exams', component: PatexamsComponent },
  {path: 'defaults', component: PatexamsComponent },
  {path: 'Custom', component: CustomheaderComponent },
  {path: 'Stats', component: StatsComponent },
  {path: 'Searchdata', component: SearchtextComponent },
  {path: 'clinic-templates', component: ClinicTemplatesComponent },
  {path: 'clinic-autotext', component: ClinicAutotextComponent },

  {path: '', component: LoginComponent},
//----------------------------US General Exam Print Start--------------------------------------------------------------------------------//
  {path: 'usgeneralprint/:examid/:PID/:LANG/:charts/:images/:style', component: UsGeneralPrintComponent},
  {path: 'usgeneralprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage', component: UsGeneralPrintComponent},
  {path: 'usgeneralprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: UsGeneralPrintComponent},
  {path: 'usgeneralprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: UsGeneralPrintComponent},


//----------------------------Clinics Builder Exam Print (GUS-88)-----------------------------------------------------//
  {path: 'clinicexamprint/:examid/:PID/:LANG/:charts/:images/:style', component: ClinicExamPrintComponent},
  {path: 'clinicexamprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage', component: ClinicExamPrintComponent},
  {path: 'clinicexamprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: ClinicExamPrintComponent},
  {path: 'clinicexamprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: ClinicExamPrintComponent},
//----------------------------Clinics Builder Exam Print End----------------------------------------------------------//

//----------------------------Endoscopy Exam Print Start--------------------------------------------------------------------------------//
  {path: 'endoscopyprint/:examid/:PID/:LANG/:charts/:images/:style', component: EndoscopyPrintComponent},
  {path: 'endoscopyprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage', component: EndoscopyPrintComponent},
  {path: 'endoscopyprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: EndoscopyPrintComponent},
  {path: 'endoscopyprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: EndoscopyPrintComponent},
//----------------------------Endoscopy Exam Print End--------------------------------------------------------------------------------//

  {path: 'statprint/:LANG/:style/:return/:type/:dates/:start/:end/:searchByType', component: PrintstatsComponent},
  {path: 'statprint/:LANG/:style/:return/:type/:dates/:start/:end/:searchByType/:code', component: PrintstatsComponent},
  
  {path: 'reportprint/:isReport/:type/:start/:end/:hmo', component: PrintreportComponent},
  {path: 'reportprint/:isReport/:type/:start/:end/:hmo/:code', component: PrintreportComponent},

  {path: 'printCalendar/:pregID', component: PrintcalendarComponent},
  {path: 'printCalendar/:pregID/:code', component: PrintcalendarComponent},

  {path: 'printPathologyForm/:examId', component: PrintPathologyFormComponent},
  {path: 'labresults', component: LabresultsComponent},
  {path: 'biopsystats', component: BiopsystatsComponent},

  {path: 'printMessengerReport/:lab/:reportid', component: MessengerReportComponent},
  {path: 'printMessengerReport/:lab/:reportid/:code', component: MessengerReportComponent},



//----------------------------Gastro Exam Print End--------------------------------------------------------------------------------//

//----------------------------Gastro Form Print Start--------------------------------------------------------------------------------//
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style', component: GsprintFormComponent},
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style/:perpage', component: GsprintFormComponent},
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: GsprintFormComponent},
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: GsprintFormComponent},
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader/:gsform', component: GsprintFormComponent},

//----------------------------Gastro Form Print End--------------------------------------------------------------------------------//

  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style', component: CardioPrintComponent},
  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage', component: CardioPrintComponent},
  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: CardioPrintComponent},
  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: CardioPrintComponent},
  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: CardioPrintComponent},

  
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style', component: PrintComponent},
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style:/perpage', component: PrintComponent},
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: PrintComponent},
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: PrintComponent},
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: PrintComponent},

  // TABLET GUI
  {path: 'tablet', component:WaitingListComponent },

  {path: 'prescriptionprint/:id/:lang/:code', component: PrescriptionPrintComponent},
  {path: 'bloodtestreferralprint/:id/:lang/:code', component: BloodTestReferralPrintComponent},
  {path: 'printUsgConsent/:autoIndex', component: PrintUsgConsentComponent},
  {path: 'printUsgConsent/:autoIndex/:code', component: PrintUsgConsentComponent},
  

  {path: 'videoserver', component: RemotevideoComponent},
  {path: 'privacy-policy', component: PrivacyPolicyComponent},
  {path: 'training-hub', component: TrainingHubComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    canceledNavigationResolution: 'replace',
    paramsInheritanceStrategy: 'emptyOnly',
    urlUpdateStrategy: 'deferred'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
